'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
var ListItem = require('./ListItem/ListItem.js');
var MobileProfileIcon = require('./MobileProfileIcon/MobileProfileIcon.js');
var MobileSidebar = require('./MobileSidebar/MobileSidebar.js');
var Avatar = require('../Avatar/Avatar.js');
require('./Navbar.scss.js');
require('./NavbarMobile.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Navbar = function (_a) {
    var navigationMenu = _a.navigationMenu, type = _a.type, isAuthenticated = _a.isAuthenticated, currentActivePage = _a.currentActivePage, isLargeScaleDisplay = _a.isLargeScaleDisplay, handleLogout = _a.handleLogout, logoPath = _a.logoPath, initialName = _a.initialName, NextLink = _a.NextLink;
    // Get all 2nd level nav items, for caching purposes
    var getAllChildItems = function () {
        var _a;
        var newArr = [];
        if (navigationMenu) {
            for (var i = 0; i < navigationMenu.length; i++) {
                if (((_a = navigationMenu[i].childItems) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    var childItem = navigationMenu[i].childItems;
                    newArr.push.apply(newArr, childItem);
                }
            }
        }
        return newArr;
    };
    var allChildItems = getAllChildItems();
    var _b = React.useState(""), hoveredParentMenu = _b[0], setHoveredParentMenu = _b[1];
    var _c = React.useState(""), selectedParentMenu = _c[0], setSelectedParentMenu = _c[1];
    var _d = React.useState(""), hoveredChildMenu = _d[0], setHoveredChildMenu = _d[1];
    var _e = React.useState(""), selectedChildMenu = _e[0], setSelectedChildMenu = _e[1];
    var _f = React.useState(allChildItems), childMenu = _f[0], setChildMenu = _f[1];
    var _g = React.useState([]), grandChildMenu = _g[0], setGrandChildMenu = _g[1];
    var _h = React.useState(false), openMobileSidebar = _h[0], setOpenMobileSidebar = _h[1];
    React.useEffect(function () {
        var childMenu = [];
        if (typeof window !== 'undefined') {
            var parentTitle_1 = hoveredParentMenu || selectedParentMenu;
            var menu = navigationMenu.find(function (row) { return row.title === parentTitle_1; });
            if (menu && menu.childItems) {
                childMenu = menu.childItems;
            }
            setChildMenu(childMenu);
        }
    }, [hoveredParentMenu]);
    React.useEffect(function () {
        if (selectedParentMenu) {
            var childMenu_1 = [];
            var menu = navigationMenu.find(function (row) { return row.title === selectedParentMenu; });
            if (menu && menu.childItems) {
                childMenu_1 = menu.childItems;
            }
            setChildMenu(childMenu_1);
        }
    }, [selectedParentMenu]);
    React.useEffect(function () {
        var grandChildMenu = [];
        var childTitle = hoveredChildMenu || selectedChildMenu;
        var menu = childMenu.find(function (row) { return row.title === childTitle; });
        if (menu && menu.childItems) {
            grandChildMenu = menu.childItems;
        }
        setGrandChildMenu(grandChildMenu);
    }, [hoveredChildMenu]);
    React.useEffect(function () {
        if (currentActivePage && navigationMenu.length) {
            preselectNavTitle();
        }
    }, [currentActivePage, navigationMenu]);
    var preselectNavTitle = function () {
        var currentPathName = currentActivePage.replace(/^\/|\/$/g, "");
        var splittedPathName = currentPathName.split("/");
        var parentPathName = splittedPathName && splittedPathName.length && splittedPathName[0];
        var childPathName = splittedPathName && splittedPathName.length > 1 && splittedPathName[1];
        switch (parentPathName) {
            case "media":
                setSelectedParentMenu("Keuangan");
                if (childPathName === "category") {
                    var grandChildPathName = splittedPathName &&
                        splittedPathName.length > 2 &&
                        splittedPathName[2];
                    switch (grandChildPathName) {
                        case "perencanaan":
                            setSelectedChildMenu("Perencanaan");
                            break;
                        case "tabungan":
                            setSelectedChildMenu("Tabungan");
                            break;
                        case "kredit":
                            setSelectedChildMenu("Kredit");
                            break;
                        case "investasi":
                            setSelectedChildMenu("Investasi");
                            break;
                        case "administrasi":
                            setSelectedChildMenu("Administrasi");
                            break;
                        case "kalkulator":
                            setSelectedParentMenu("Konsultasi");
                            setSelectedChildMenu("Kalkulator & Kuis");
                            break;
                        case "berita-riset":
                            setSelectedParentMenu("Berita & Riset");
                            setSelectedChildMenu("");
                            break;
                    }
                }
                break;
            case "asuransi":
                setSelectedParentMenu("Asuransi");
                switch (childPathName) {
                    case "kesehatan":
                        setSelectedChildMenu("Kesehatan");
                        break;
                    case "jiwa":
                        setSelectedChildMenu("Jiwa");
                        break;
                    case "kendaraan":
                        setSelectedChildMenu("Kendaraan");
                        break;
                }
                break;
            case "penawaran":
                setSelectedParentMenu("Asuransi");
                setSelectedChildMenu("Dapatkan Penawaran");
                break;
            case "cek-keuangan":
                setSelectedParentMenu("Konsultasi");
                setSelectedChildMenu("Cek Keuangan");
                break;
            case "account":
                setSelectedParentMenu("Login");
                break;
        }
    };
    var menuItem = function (props) {
        var item = props.item, index$1 = props.index, isAgent = props.isAgent, isSelected = props.isSelected, isChildMenu = props.isChildMenu, onMouseOver = props.onMouseOver, onClick = props.onClick, onMouseLeave = props.onMouseLeave;
        var handleAgentIcon = function (iconName) {
            if (iconName.includes('whatsapp')) {
                return "lifepal__icon lifepal__icon--whatsapp--white";
            }
            else if (iconName.includes('profile')) {
                return "lifepal__icon lifepal__icon--profile--white";
            }
            else {
                return iconName;
            }
        };
        var handleUserIcon = function (iconName) {
            if (iconName.includes('whatsapp')) {
                return "lifepal__icon lifepal__icon--whatsapp";
            }
            else if (iconName.includes('login')) {
                return "lifepal__icon lifepal__icon--login";
            }
            else {
                return iconName;
            }
        };
        return (React__default['default'].createElement("li", { key: index$1, className: index['default'](item.stylingClass, isSelected && isAgent ? "selected--agent" : isSelected ? "selected" : ""), onMouseOver: onMouseOver, onClick: onClick, onMouseLeave: onMouseLeave },
            item.iconName && React__default['default'].createElement("i", { className: isAgent ? handleAgentIcon(item.iconName) : handleUserIcon(item.iconName) }),
            isLargeScaleDisplay && item.link !== "#" ? (NextLink ?
                React__default['default'].createElement(NextLink, { href: item.link },
                    React__default['default'].createElement("a", { className: index['default']("child__anchor", item.title === "Dapatkan Penawaran" ? "color__blue" : ""), title: item.title }, item.title)) :
                React__default['default'].createElement("a", { className: index['default']("child__anchor", item.title === "Dapatkan Penawaran" ? "color__blue" : ""), href: (item.title === 'Bantuan' && isAuthenticated) ? '/bantuan/' : item.link, target: item.target || "", rel: "noopener noreferrer", title: item.title }, item.title)) : (item.title),
            isChildMenu &&
                isSelected &&
                grandChildMenu.length > 0 &&
                hoveredChildMenu === item.title && (React__default['default'].createElement("ul", { className: "child__items", onMouseLeave: function () { return setHoveredChildMenu(""); } }, grandChildMenu.map(function (grandChild) {
                return React__default['default'].createElement(ListItem.ListItem, { item: grandChild, NextLink: NextLink });
            })))));
    };
    return (React__default['default'].createElement("nav", { className: index['default']("navigation", type === "agent" && "is__agent") },
        React__default['default'].createElement("div", { className: "navigation__container" },
            !isLargeScaleDisplay && (React__default['default'].createElement("div", { className: "navigation__mobile--burger", onClick: function () { return setOpenMobileSidebar(true); } },
                React__default['default'].createElement("i", { className: "lifepal__icon lifepal__icon--burger" + (type === 'agent' ? "--white" : "") }))),
            React__default['default'].createElement("div", { className: "navigation__brand" },
                React__default['default'].createElement("a", { href: "/" }, type === "user" ? (React__default['default'].createElement("img", { src: logoPath, alt: "lifepal-user-logo", width: "91px", height: "31px" })) : (React__default['default'].createElement(Avatar.Avatar, { src: logoPath, alt: "lifepal-agent-logo", maxWidth: "100%", maxHeight: "30px" })))),
            !isLargeScaleDisplay && (React__default['default'].createElement(MobileProfileIcon, { isAuthenticated: isAuthenticated, isAgent: type === "agent", initialName: initialName, handleLogout: function () { return handleLogout(); }, NextLink: NextLink })),
            isLargeScaleDisplay && (React__default['default'].createElement("div", { className: "navigation__menu", onMouseLeave: function () {
                    setHoveredParentMenu("");
                    setSelectedParentMenu(selectedParentMenu);
                } },
                React__default['default'].createElement("ul", { className: "navigation__menu--parent" }, navigationMenu.map(function (row, i) {
                    return menuItem({
                        item: row,
                        index: i,
                        isAgent: type === "agent",
                        isSelected: [hoveredParentMenu, selectedParentMenu].includes(row.title),
                        onMouseOver: function () { return setHoveredParentMenu(row.title); },
                    });
                })),
                React__default['default'].createElement("ul", { className: "navigation__menu--child" }, childMenu.map(function (row, i) {
                    return (row.title.toLowerCase() != 'faq') &&
                        menuItem({
                            item: row,
                            index: i,
                            isAgent: type === "agent",
                            isSelected: [hoveredChildMenu, selectedChildMenu].includes(row.title),
                            isChildMenu: true,
                            onMouseOver: function () { return setHoveredChildMenu(row.title); },
                            onClick: function () { return row.title === "Keluar" && handleLogout(); },
                            onMouseLeave: function () { return setHoveredChildMenu(""); },
                        });
                }))))),
        !isLargeScaleDisplay && openMobileSidebar &&
            React__default['default'].createElement(MobileSidebar, { onCloseClick: function () { return setOpenMobileSidebar(false); }, logoPath: logoPath, navigationMenu: navigationMenu, childMenu: childMenu, grandChildMenu: grandChildMenu, NextLink: NextLink })));
};

exports.Navbar = Navbar;
//# sourceMappingURL=Navbar.js.map
